<template>
  <div class="custom-form__captcha">
    <load-script v-if="config.enterpriseCaptchaApi" :src="config.enterpriseCaptchaApi" name="recaptcha enterprise"/> 
    <!-- src="https://www.google.com/recaptcha/enterprise.js?render=KEY_ID" -->
    <div id="enterprise-captcha" class="g-recaptcha g-recaptcha-enterprise"/>
    <p class="field-help"
           v-if="hasErrorCaptcha"
           id="captcha-error-text">
          {{ config.ErrorMessage }}
    </p>
  </div>
</template>

<script>
  import LoadScript from '@Foundation/loadscript/loadscript';
  import RECAPTCHA_ENTERPRISE from '@Feature/Mixins/recaptcha-enterprise.mixin';

  export default {
    name: 'captcha-enterprise',
    components: { LoadScript },
    mixins :[RECAPTCHA_ENTERPRISE],
  };
</script>

<style lang="scss" src="./captcha-enterprise.scss"></style>